import wixWindow from 'wix-window';
const RTLLangs = ['he','ar','fa'];
$w.onReady(function () {
    let lang = wixWindow.multilingual.currentLanguage;
    //based on RTL
    /////////////////////////////////////
    if(RTLLangs.includes(lang)){
        $w('#statebox8').changeState('RTL');
        }
        });